import { render, staticRenderFns } from "./RoundBoard.vue?vue&type=template&id=7795c218&scoped=true&"
import script from "./RoundBoard.vue?vue&type=script&lang=ts&"
export * from "./RoundBoard.vue?vue&type=script&lang=ts&"
import style0 from "./RoundBoard.vue?vue&type=style&index=0&id=7795c218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7795c218",
  null
  
)

export default component.exports